export interface PairingCodeResult {
    client_values: RedirectUrls;
}

export interface PairingCodeError {
    error: { detail: string };
}

export interface RedirectUrls {
    redirectUrl?: string;
    redirectUrlMobile?: string;
    redirectUrlRetail?: string;
}

export const EXPIRED_CODE_ERROR_DETAIL = 'pairing code expired';
